module.exports = __webpack_public_path__ + "static/media/privacy-week-splash-mobile.a27a83a5.png";